import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ArtifactAccessibilityModel, AuditFrequencyModel, DevelopmentMethodologyModel, ProjectDetailsModel, projectNamesModel } from './DataModels';
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuditdetailsserviceService {
  
  private ApiUrl = environment.apiUrl;
  constructor(private http:HttpClient) { }
  
  saveAuditcreation(data:any):Observable<any>{    
    return this.http.post<any>(this.ApiUrl + 'AuditCreation/CreateOrUpdateAudit',data);

  }
  getPortfolioLeaderByProjectId(projectId:number){  
    return this.http.get(this.ApiUrl + 'AuditDetails/GetPortfolioLeaderByProjectId?ProjectId='+ projectId);

  }
  getAllLeadersName(){
    return this.http.get<any>(this.ApiUrl + 'AuditCreation/GetPortfolioLeaders');

  }
  saveManagerAuditdetails(data:any):Observable<any>{
    return this.http.post<any>(this.ApiUrl + 'AuditCreation/CreateOrUpdateAudit',data);
  }

  getcategorydetails():Observable<any>
    {
      return this.http.get<any>(this.ApiUrl+"ProjectContactDetails/getClientValue");
    }
 
  getProjectName():Observable<projectNamesModel[]>{
    return this.http.get<projectNamesModel[]>(this.ApiUrl+`AuditCreation/GetProjectName`);
  }
  getProjectNameByManagerId(managerId:number):Observable<projectNamesModel[]>{
    const requestUrl = `${this.ApiUrl}AuditCreation/GetProjectName?managerId=${managerId}`;
    return this.http.get<projectNamesModel[]>(requestUrl);
  }
  getProjectDetailsById(projectId: number): Observable<ProjectDetailsModel[]> {
    const requestUrl = `${this.ApiUrl}AuditDetails/GetProjectDetailsById?projectId=${projectId}`;
    return this.http.get<ProjectDetailsModel[]>(requestUrl);
  }
  getArtifactsAccessabiity():Observable<ArtifactAccessibilityModel[]>{
    return this.http.get<ArtifactAccessibilityModel[]>(this.ApiUrl + 'AuditArtifacts/GetArtifactsAccessabiity')
  }

  GetDevelopmentMethodologyTypes():Observable<DevelopmentMethodologyModel[]>{
    return this.http.get<DevelopmentMethodologyModel[]>(this.ApiUrl + 'AuditCreation/GetDevelopmentMethodologyTypes')
  }

  getTechStack(projectid:any){
    return this.http.get(this.ApiUrl + 'AuditDetails/GetTeckStackbyProjectId?projectId='+projectid)
  }

  getAuditorName(){
    return this.http.get(this.ApiUrl+'AuditDetails/GetAuditorName');
  }
  getPointOfContactTypes(){
    return this.http.get(this.ApiUrl+'AuditCreation/GetPointOfContactTypes');
  }
  getArtifactTypes(){
    return this.http.get(this.ApiUrl+'AuditArtifacts/GetArtifactType');
  }
  getManagerName(projectid:number){
    
    return this.http.get(this.ApiUrl+'AuditDetails/GetManagerNamebyProjectId?ProjectId='+projectid)
  }

  getSubAuditorName(){
    return this.http.get(this.ApiUrl+'AuditDetails/GetSubAuditorsName');

  }

  getPointofContactName(projectid:number){
    return this.http.get(this.ApiUrl+'AuditDetails/GetPointofContactName?ProjectId='+projectid);
  }

  getProjectPointofContactName(projectid:number){
      return this.http.get(this.ApiUrl+'AuditDetails/GetProjectPointofContactNamebyProjectId?projectId='+projectid);
  }

  getProjectManagerNamesByProjectId(projectId:number){
    return this.http.get(this.ApiUrl + 'AuditDetails/GetManagerNamebyProjectId?ProjectId='+ projectId);
  }

  getMiddleTierorCloudPointofContactName(projectid:number){
    return this.http.get(this.ApiUrl+'AuditDetails/GetMiddleTierorCloudPointofContactNamebyProjectId?projectId='+ projectid);
  }
  getFunctionalOverviewPointOfContacts(projectid:number){
    return this.http.get(this.ApiUrl + 'AuditPointOfContacts/GetFunctionalOverviewPointOfContactsbyProjectId?projectId='+ projectid);
  }
  getOverAllApplicationPointOfContacts(projectid:number){
    return this.http.get(this.ApiUrl + 'AuditPointOfContacts/GetOverAllApplicationPointOfContactsbyProjectId?projectId='+ projectid);
  }
  getOverAllArchitecturePointOfContacts(projectid:number){
    return this.http.get(this.ApiUrl + 'AuditPointOfContacts/GetOverAllArchitecturePointOfContactsbyProjectId?projectId=' + projectid);
  }
  getOverAllDesignPointOfContacts(projectid:number){
    return this.http.get(this.ApiUrl + 'AuditPointOfContacts/GetOverAllDesignPointOfContactsbyProjectId?projectId=' + projectid);
  }
  getTechnicalPointOfContacts(projectid:number){
    return this.http.get(this.ApiUrl + 'AuditPointOfContacts/GetTechnicalPointOfContactsbyProjectId?projectId=' + projectid);
  }
  getNonTechnicalPointOfContacts(projectid:number){
    return this.http.get(this.ApiUrl + 'AuditPointOfContacts/GetNonTechnicalPointOfContactsbyProjectId?projectId=' + projectid);
  }
  getAuditInfoByAuditId(auditId:number){
    return this.http.get(this.ApiUrl + 'AuditCreation/GetAuditDetailsById?AuditId=' + auditId);
  }

  getAllManagersName(){
    return this.http.get(this.ApiUrl +'AuditCreation/GetManagerName');
  }

  getAllDeliveryManagerNames(){
    return this.http.get(this.ApiUrl +'AuditCreation/GetDeliveryManagerName');
  }

  getAuditFrequencyOptions(): Observable<Array<AuditFrequencyModel>>{
    const endPointUrl:string = `AuditCreation/GetAuditFrequencies`;
    return this.http.get<AuditFrequencyModel[]>(this.ApiUrl+ endPointUrl);   
  }

}